export enum PermissionSet {
    SHOW_PS_V_SHOW_ITEMS = 'SHOW_PS_V_SHOW_ITEMS',
    SHOW_PS_M_SITE_CONTENT = 'SHOW_PS_M_SITE_CONTENT',
    SHOW_PS_M_ATTENDANCE = 'SHOW_PS_M_ATTENDANCE',
}
